import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';


export const Item = styled.li`

    position:relative;
    display: inline-block;
    padding: 0rem 0.5rem;
    ${breakpoint('xs','sm')`  
        width: 100%;  
`}


    

`

export const MyLink = styled.a`
    &:link,
    &:visited{
        display: inline-block;
        color:#fff;
        font-size: 1.4rem;
        font-weight: 700;
        text-decoration:none;
        transition: all .3s; 
        padding:1rem; 
        border-right: 6px solid;
        border-color: transparent;

        ${breakpoint('xs','sm')`  
            width: 95%; 
            margin-top: 1rem;
    `}


        
    }

    
    &::after,
    &::before{
        position: absolute;
        content: "";
        transform: scaleX(0);
        height: 6px;
        width: 100%;
        background-color: #606c88;
        left:0;
        transition: all .3s .3s;
        transform-origin: right;

    }

    &::after{
        top: 0;
    }

    &::before{
        bottom:0;
    }
  
    &:hover,
    &:active{
        border-right: 6px solid;
        border-color:#606c88;
        transform: scale(1.1);

    }

    &:hover::after,
    &:active{
        transform: scaleX(1);
    }
    
    &:hover::before,
    &:active{
        transform: scaleX(1);
    }

    ${props =>
        props.active &&
        css`
        ::after,
        ::before{
        transform: scaleX(1);

        }

        &:link,
        &:visited{
            border-right: 6px solid;
            border-color:#606c88;
            transform: scale(1.1);

            ${breakpoint('xs','sm')`  
            transform: scale(1);
            `}



        }

        `
    }


`